import ReportWithoutCriteria from '../ReportWithoutCriteria';
import {
  AUDIO_ABBREVIATIONS_REPORT_ERROR,
  AUDIO_ABBREVIATIONS_REPORT_LOADING,
  AUDIO_ABBREVIATIONS_REPORT_SUCCESS,
} from './reportStates';

export default function AudioAbbreviationReport({
  getLatestAudioAbbreviationsReport,
  generateAudioAbbreviationsReport,
  audioAbbreviationReport,
}) {
  return (
    <ReportWithoutCriteria
      name="Audio Abbreviations Report"
      link={audioAbbreviationReport.data.link}
      currentState={audioAbbreviationReport.state}
      stateLoading={AUDIO_ABBREVIATIONS_REPORT_LOADING}
      stateError={AUDIO_ABBREVIATIONS_REPORT_ERROR}
      stateSuccess={AUDIO_ABBREVIATIONS_REPORT_SUCCESS}
      getLatestFunc={getLatestAudioAbbreviationsReport}
      generateFunc={generateAudioAbbreviationsReport}
    />
  );
}
